import { render, staticRenderFns } from "./ImportSetToCustomer.vue?vue&type=template&id=4b34b96e&scoped=true"
import script from "./ImportSetToCustomer.vue?vue&type=script&lang=js"
export * from "./ImportSetToCustomer.vue?vue&type=script&lang=js"
import style0 from "./ImportSetToCustomer.vue?vue&type=style&index=0&id=4b34b96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b34b96e",
  null
  
)

export default component.exports